const PRODUCTION_ORIGIN = 'https://app.sporto.id';

// Popup Sign in with Apple memakai response_mode=web_message.
// Origin redirect URI harus sama dengan halaman yang membuka popup.
// Callback API hanya untuk flow redirect lama, bukan untuk popup ini.
export const appleRedirectUri = (): string => {
  if (typeof window !== 'undefined' && window.location.origin && window.location.origin !== 'null') {
    return window.location.origin;
  }
  return PRODUCTION_ORIGIN;
};
